// AUTO-GENERATED quiz prompts (NO answer keys). Keys live server-side only.
// Regenerate: scripts/gen_quiz.py

export const QUIZ_QUESTIONS = [
  {
    id: "Q-A", points: "1 pt", page: 1,
    prompt: `What happens when you run this file? Identify the problem.`,
    code: `import trio
def example():
    print("Start")
    await trio.sleep(1)
    print("Middle")
    await trio.sleep(1)
    print("End")

trio.run(example)`
  },
  {
    id: "Q-B", points: "1 pt", page: 1,
    prompt: `what is wrong with this code?`,
    code: `import trio
async def process_task(result_dict):
    await trio.sleep(2)
    result_dict['status'] = 'completed'

async def main():
    results = {}
    nursery = trio.open_nursery()
    nursery.start_soon(process_task, results)
    await trio.sleep(1)
    print(f"Results: {results}")

trio.run(main)`
  },
  {
    id: "Q-C", points: "1 pt", page: 1,
    prompt: `What happens when this program runs? Identify the problem.`,
    code: `import trio
async def foo():
    print("Start")
    await trio.sleep(1)
    print("End")

async def main():
    with trio.open_nursery() as nursery:
        nursery.start_soon(foo)
    print("Task complete")

trio.run(main)`
  },
  {
    id: "Q-D", points: "2 pts", page: 2,
    prompt: `What does this program print? What is the final value of \`output\`, and why?`,
    code: `import trio
async def get_lemon():
    print("Getting lemon");  await trio.sleep(1);    return "lemon"
async def get_apple():
    print("Getting apple");  await trio.sleep(0.5);  return "apple"
async def get_orange():
    print("Getting orange"); await trio.sleep(0.25); return "orange"

async def main():
    async with trio.open_nursery() as nursery:
        output = nursery.start_soon(get_lemon)
        output = nursery.start_soon(get_apple)
        output = nursery.start_soon(get_orange)
    print("Task complete")
    print(output)

trio.run(main)`
  },
  {
    id: "Q-E", points: "2 pts", page: 2,
    prompt: `In what order do the lines print? Why?`,
    code: `import trio
async def example():
    await trio.sleep(1); print("Lemon")
    await trio.sleep(1); print("Orange")

async def main():
    async with trio.open_nursery() as nursery:
        nursery.start_soon(example)
        print("Apple")

trio.run(main)`
  },
  {
    id: "Q-F", points: "2 pts", page: 2,
    prompt: `Same code as Q-E, but the last line is \`trio.run(example)\`. Now what prints, and why?`,
    code: ``
  },
  {
    id: "Q-G", points: "1 pt", page: 3,
    prompt: `Review the following code snippet and identify the bug`,
    code: `import trio
async def process_item(item):
    return item * 2

async def process_data(items):
    results = []
    async with trio.open_nursery() as nursery:
        for item in items:
            result = await process_item(item)
            results.append(result)
    return results`
  },
  {
    id: "Q-H", points: "2 pts", page: 3,
    prompt: `what is wrong with this code? where is the await missing?`,
    code: `import trio
async def fetch_data(user_id):
    await trio.sleep(1)
    return {'id': user_id, 'data': f'User data for {user_id}'}

async def process_users(user_ids):
    all_data = {}
    async def process_one_user(uid):
        data = fetch_data(uid)
        all_data[uid] = data
    async with trio.open_nursery() as nursery:
        for uid in user_ids:
            nursery.start_soon(process_one_user, uid)
    return all_data

trio.run(process_users, [1, 2, 3])`
  },
  {
    id: "Q-I", points: "2 pts", page: 3,
    prompt: `Review the code and describe the bug`,
    code: `import trio
async def run_with_timeout():
    with trio.move_on_after(1):
        print("Starting task")
        await long_running_task()

async def long_running_task():
    await trio.sleep(2)
    print("Task completed")

trio.run(run_with_timeout)`
  },
  {
    id: "Q-J", points: "2 pts", page: 4,
    prompt: `What does this program print, and approximately how long does it take? Explain why.`,
    code: `import trio, time
async def child1(): await trio.sleep(0.5)
async def child2(): await trio.sleep(1.5)

start_time = time.time()
async def parent():
    print(f"parent: started! {time.time()-start_time}s")
    async with trio.open_nursery() as nursery:
        await child1()
        await child2()
        print("parent: waiting for children to finish...")
    print(f"parent: all done! {time.time()-start_time}s")

trio.run(parent)`
  },
  {
    id: "Q-K", points: "3 pts", page: 4,
    prompt: `Trace the execution flow of this code and identify when each task runs and completes:`,
    code: `import trio
async def task_with_subtasks():
    print("Parent: starting")
    async with trio.open_nursery() as subtask_nursery:
        subtask_nursery.start_soon(subtask, 1)
        print("Parent: spawned first subtask")
        await trio.sleep(0.5)
        subtask_nursery.start_soon(subtask, 2)
        print("Parent: spawned second subtask")
    print("Parent: subtasks complete")

async def subtask(number):
    print(f"Subtask {number}: starting")
    await trio.sleep(1)
    print(f"Subtask {number}: finished")

trio.run(task_with_subtasks)`
  },
  {
    id: "Q-L", points: "2 pts", page: 5,
    prompt: `What will be the output of this code, and why?`,
    code: `import trio
async def task(n):
    if n == 2:
        raise ValueError("Task 2 fails")
    await trio.sleep(0.5)
    print(f"Task {n} ending")

async def main():
    async with trio.open_nursery() as nursery:
        for i in [1, 2, 3]:
            nursery.start_soon(task, i)
    print("Main complete")

trio.run(main)`
  },
  {
    id: "Q-M", points: "3 pts", page: 5,
    prompt: `Given this code snippet, what would be the order of what is printed?`,
    code: `import trio
user_ids = [1, 2, 3, 4, 5]
async def get_user_id(user_id: int, my_results: dict) -> dict:
    await trio.sleep(1)
    if user_id % 2 == 0:
        my_results[user_id] = f"User {user_id}"
    else:
        my_results[user_id] = "error"
        raise ValueError(f"User {user_id} not found")

async def main():
    results = {}
    try:
        async with trio.open_nursery() as nursery:
            for user_id in user_ids:
                nursery.start_soon(get_user_id, user_id, results)
    except ValueError:
        print("ValueError")
    print(results)

trio.run(main)`
  },
  {
    id: "Q-N", points: "3 pts", page: 5,
    prompt: `Trace the execution of this code with race conditions. What are the possible outputs?`,
    code: `import trio
shared_counter = 0

async def increment_counter(id, n_times):
    global shared_counter
    for _ in range(n_times):
        current = shared_counter
        await trio.sleep(0.01)
        shared_counter = current + 1
        print(f"Task {id} incremented to {shared_counter}")

async def main():
    async with trio.open_nursery() as nursery:
        nursery.start_soon(increment_counter, 1, 3)
        nursery.start_soon(increment_counter, 2, 3)
    print(f"Final counter value: {shared_counter}")

trio.run(main)`
  },
]
